<template>
  <Header :style="{position: 'absolute', top:0, width: '100%',minWidth: '1024px'}">
    <!-- logo -->
    <div :class="[!isCollapsed?'logo-large-icon':'logo-small-icon']">
      <img v-show="!isCollapsed" key="max-logo" :src="maxLogo" />
      <img v-show="isCollapsed" key="min-logo" :src="minLogo" />
    </div>
    <!-- navbar -->
    <div :class="[!isCollapsed?'navbar':'navbar-toggle']">
      <span @click="collapsedSider">
        <Icon class="toggle-tap" type="md-menu" size="18" />
      </span>

      <router-link :to="channel ? '/channel': '/home'" tag="span" :class="(channel? router.indexOf('home')>-1 : router.indexOf('channel')>-1)?'active':''"> {{ $t('WorkBench') }}</router-link>
      <router-link
        v-if="channel" to="/channelClue/channelAllClue" tag="span"
        :class="router.indexOf('channelClue')>-1?'active':''"
      >
        {{ $t('ClueManage') }}
      </router-link>
      <router-link
        v-if="channel" to="/channelCase/channelCivilCase" tag="span"
        :class="router.indexOf('channelCase')>-1?'active':''"
      >
        {{ $t('CaseManage') }}
      </router-link>

      <router-link
        v-if="!channel" to="/project/projectList" tag="span"
        :class="router.indexOf('project')>-1?'active':''"
      >
        {{ $t('Project') }}
      </router-link>
      <router-link
        v-if="!channel" to="/gen/allGen" tag="span"
        :class="router.indexOf('gen')>-1?'active':''"
      >
        {{ $t('IntelligenceManage') }}
      </router-link>
      <router-link
        v-if="!channel" to="/clue/reviewedClue" tag="span"
        :class="router.indexOf('clue')>-1?'active':''"
      >
        {{ $t('ClueManage') }}
      </router-link>
      <router-link
        v-if="!channel" to="/case/civilCase" tag="span"
        :class="router.indexOf('case')>-1?'active':''"
      >
        {{ $t('CaseManage') }}
      </router-link>
      <router-link
        v-if="isAdmin && !channel"
        to="/setting/memberManage" tag="span"
        :class="router.indexOf('setting')>-1?'active':''"
      >
        {{ $t('MemberManage') }}
      </router-link>
      <!-- <router-link to="/settlementCenter/invoicing/list/index" tag="span" :class="router.indexOf('settlementCenter')>-1?'active':''">{{ $t('SettlementCenter') }}</router-link> -->
      <router-link
        v-if="supplierPermission && !channel" to="/supplier/supplierManage" tag="span"
        :class="router.indexOf('supplier')>-1?'active':''"
      >
        {{ $t('SupplierManage') }}
      </router-link>
      <router-link
        v-if="!channel" to="/tools/onlineMonitor" tag="span"
        :class="router.indexOf('tools')>-1?'active':''"
      >
        {{ $t('Tools') }}
      </router-link>
      <a
        href="http://iptech.andunip.com/" target="_blank"
      >
        {{ $t('IntellectualPropertySaaS') }}
      </a>
      <router-link
        v-if="false" to="/taskHall/publicTask" tag="span"
        :class="router.indexOf('taskHall')>-1?'active':''"
      >
        {{ $t('TaskHall') }}
      </router-link>
      <span v-if="false" :class="router.indexOf('doingTask')>-1?'active':''" @click="hideOrShow('taskHall')">
        {{ $t('DoingTask') }}
        <div v-if="taskCtrl" class="inside-menu-tab" style="width:180px;">
          <router-link to="/doingTask/myClueTask">
            <div>
              <Icon type="ios-locate-outline" size="24" />
              <h5>{{ $t("Clue") }}</h5>
            </div>
          </router-link>
          <router-link to="/doingTask/myRuningCase">
            <div>
              <Icon type="ios-bookmark-outline" size="24" />
              <h5>{{ $t("Case") }}</h5>
            </div>
          </router-link>
        </div>
      </span>
      <router-link
        v-if="false" to="/myTeam/personnelManagement" tag="span"
        :class="router.indexOf('myTeam')>-1?'active':''"
      >
        {{ $t('Team') }}
      </router-link>
      <router-link v-if="false" to="/waitting" tag="span">{{ $t('Financ') }}</router-link>
      <router-link v-if="false" to="/waitting" tag="span">{{ $t('Riskloan') }}</router-link>
    </div>
    <!-- 通知、中英文、个人中心 -->
    <div class="header-right">
      <!-- 通知 -->
      <!-- <div class="header-notice clearfix" @click="hideOrShow('notice')">
                <Badge :count="100" :offset="[13,24]" type="normal" style="cursor:pointer" :class="noticeCtrl?'active':''">
                    <Icon type="ios-notifications-outline" size="24" color="#fff"></Icon>
                </Badge>
                <div class="more-router" v-show="noticeCtrl">
                    <Card :title="'您有'+noticeArr.length+'条通知'" :padding="0" shadow style="width: 280px;">
                        <Scroll :on-reach-bottom="handleReachBottom" :loading-text="loadingText" height="184" :distance-to-edge="10">
                            <CellGroup>
                                <Cell
                                title="Link"
                                to="/components/button"
                                v-for="(item,index) in noticeArr"
                                :key="index"
                                class="notice-tips"
                                >
                                <Icon type="md-contacts" size="18" color="#ed4014"/>
                                <h5 :title="item.content">{{item.content}}</h5>
                                </Cell>
                            </CellGroup>
                        </Scroll>
                    </Card>
                </div>
            </div> -->
      <!-- 中英文 -->
      <span>
        <Dropdown trigger="click" @on-click="toggleLang($event)">
          <a href="javascript:void(0)" style="color:#fff;">{{ langStr }}
            <Icon type="ios-arrow-down" />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="zh-CN">中文</DropdownItem>
            <DropdownItem name="en-US">English</DropdownItem>
            <DropdownItem name="ko-KR">한국어</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </span>
      <!-- 切换团队 -->
      <span v-if="false">
        <Dropdown trigger="click" @on-click="toggleTeam">
          <a href="javascript:void(0)" style="color:#fff;">{{ currentTeam }}
            <Icon type="ios-arrow-down" />
          </a>
          <DropdownMenu slot="list">
            <DropdownItem name="zh-CN">律师团队</DropdownItem>
            <DropdownItem name="en-US">调查员团队</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </span>
      <!-- 个人中心 -->
      <span :class="[infoCtrl?'active':'','head-img-box']" @click="hideOrShow('info')">
        <img :src="src" alt="">&nbsp;{{ name }}
        <Card v-show="infoCtrl" class="more-router" :padding="0">
          <Col class="info-box">
            <img
              class="head-img"
              :src="src"
            >
            <p>{{ companyName }}</p>
            <p class="small-p">{{ name }}</p>
          </Col>
          <Col class="info-btn-box">
            <router-link to="/personalCenter/information"><Button>{{ $t("MyCenter") }}</Button></router-link>
            <!-- <Button>{{$t("ResetPwd")}}</Button> -->
            <Button @click="$router.push({path:'/login'});">{{ $t("Exit") }}</Button>
          </Col>
        </Card>
      </span>
    </div>
  </Header>
</template>
<script>
import userLogo from '@/assets/images/card-02.png'
export default {
  components: {

  },
  props: [''],
  data () {
    return {
      currentUser: {},
      name: '',
      companyName: '',
      isCollapsed: false,
      taskCtrl: false,
      noticeCtrl: false,
      isAdmin: false,
      channel: false,
      maxLogo: require('./../../assets/images/logo.png'),
      minLogo: require('./../../assets/images/logo-small.png'),
      noticeArr: [
        {
          id: 1,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 2,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 3,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 4,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        },
        {
          id: 5,
          content: '您报备的线索“S20180315382379-海尔、Haier商标侵权线索全国调查-" tb67348189"”被驳回，再接再厉哦！'
        }
      ],
      loadingText: '加载中',
      langStr: '中文',
      currentTeam: '律师团队',
      infoCtrl: false,
      src: userLogo,
      supplierPermission: false
    }
  },
  computed: {
    router() {
      this.getMenu(this.$route.path)
      return this.$route.path
    }
  },
  watch: {
    router(val, oldVal) {
      console.log('val', val)

      this.getMenu(val)
    }
  },
  created() {
    this.getSupplierPermission()
    const navLang = navigator.language
    const localLang = (navLang === 'zh-CN' || navLang === 'en' || navLang === 'ko') ? navLang : false
    switch (localLang) {
      case 'zh-CN':
        this.langStr = '中文'
        break
      case 'en':
        this.langStr = 'English'
        break
      case 'ko':
        this.langStr = '한국어'
        break
    }
  },
  beforeMount() {
    this.currentUser = window.localStorage.getItem('currentUser')
    console.log(this.currentUser)
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.taskCtrl = false
        this.noticeCtrl = false
        this.infoCtrl = false
      }
    })
    this.getCustomerDetail()
  },
  updated() {

  },
  methods: {
    // 获取用户是否有供应商管理的权限
    getSupplierPermission() {
      const url = '/saas-cases/customer/permission'
      this.$get(url).then(res => {
        if (res.code === 0) {
          const data = res.data === true
          this.supplierPermission = data
        } else {
          this.supplierPermission = false
        }
      }).catch(err => {
        this.supplierPermission = false
      })
    },
    collapsedSider () {
      this.isCollapsed = !this.isCollapsed
      this.$store.commit('toggleCollapsed', this.isCollapsed)
    },
    // 通知栏移动到底部加载更多
    handleReachBottom() {
      const t = this
      this.c++
      // 必须返回一个promise
      return new Promise(resolve => {
        if (t.c >= 3) {
          t.loadingText = '没有更多数据了'
          resolve()
          return
        }
        setTimeout(() => {
          t.noticeArr.push({
            id: 2,
            content: '测试数据测试数据'
          })
          resolve()
        }, 2000)
      })
    },
    // 切换中英文
    toggleLang(name) {
      switch (name) {
        case 'zh-CN' :
          this.langStr = '中文'
          break
        case 'en-US' :
          this.langStr = 'English'
          break
        case 'ko-KR' :
          this.langStr = '한국어'
          break
      }
      this.$i18n.locale = name
      console.log('进入了')
    },
    // 切换团队
    toggleTeam() {

    },
    // 控制路由
    getMenu(val) {
      if (val.indexOf('clue') > -1) {
        if (!this.supplierPermission) { // 控制是否有供应商权限 展示列表
          const arr = this.menu.clueList.slice(0, 1)
          this.$store.commit('changeMenu', arr)
        } else {
          this.$store.commit('changeMenu', this.menu.clueList)
        }
      } else if (val.indexOf('personalCenter') > -1) {
        this.$store.commit('changeMenu', this.menu.personalCenterList)
      } else if (val.indexOf('setting') > -1) {
        this.$store.commit('changeMenu', this.menu.settingList)
      } else if (val.indexOf('project') > -1) {
        this.$store.commit('changeMenu', this.menu.projectList)
      } else if (val.indexOf('case') > -1) {
        if (!this.supplierPermission) { // 控制是否有供应商权限 展示列表
          const arr = this.menu.caseList.slice(0, 1)
          this.$store.commit('changeMenu', arr)
        } else {
          this.$store.commit('changeMenu', this.menu.caseList)
        }
      } else if (val.indexOf('tools') > -1) {
        this.$store.commit('changeMenu', this.menu.toolList)
      } else if (val.indexOf('channelCase') > -1) {
        this.$store.commit('changeMenu', this.menu.channelCaseList)
      } else if (val.indexOf('channelClue') > -1) {
        this.$store.commit('changeMenu', this.menu.channelClueList)
      } else if (val.indexOf('gen') > -1) {
        this.$store.commit('changeMenu', this.menu.genList)
      } else if (val.indexOf('supplier') > -1) {
        this.$store.commit('changeMenu', this.menu.supplierList)
      } else if (val.indexOf('settlementCenter') > -1) {
        this.$store.commit('changeMenu', this.menu.settlementCenterList)
      }
    },
    hideOrShow(type) {
      if (type === 'taskHall') {
        this.taskCtrl = !this.taskCtrl
        this.noticeCtrl = false
        this.infoCtrl = false
      } else if (type === 'notice') {
        this.noticeCtrl = !this.noticeCtrl
        this.taskCtrl = false
        this.infoCtrl = false
      } else if (type === 'info') {
        this.infoCtrl = !this.infoCtrl
        this.noticeCtrl = false
        this.taskCtrl = false
      }
    },
    // 获取律师详情
    getCustomerDetail() {
      const url = '/base/customer-member/my'
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.isAdmin = res.data.isAdmin
          this.name = res.data.name
          this.companyName = res.data.companyName
          this.src = res.data.completeIcon ? res.data.completeIcon : userLogo
          this.channel = res.data.type == 'C'
        }
      })
    }
  }
}
</script>
<style lang="sass" scoped>
 @import './header.scss';
</style>
<style lang="scss">
    .notice-tips .ivu-cell-arrow {
        right: 5px;
    }
    .notice-tips .ivu-cell-title {
        line-height: normal;
    }
    .ivu-cell-title {
        line-height: 24px;
        font-size: 14px;
    }
    .notice-tips:last-child {
        border: none;
    }
    .more-router {
        .ivu-card-head {
            padding: 7px 10px;
        }
        .ivu-scroll-loader:first-child {
            display: none;
        }
        .ivu-spin-text {
            i {
                opacity: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/header/header.vue